import React from 'react';
import { Provider, createStoreHook, createDispatchHook, createSelectorHook } from 'react-redux';

const baseContext = React.createContext(null);

export const useStore = createStoreHook(baseContext);
export const useDispatch = createDispatchHook(baseContext);
export const useSelector = createSelectorHook(baseContext);

const BaseProvider = ({ children, store }) => {
  return (
    <Provider context={baseContext} store={store}>
      {children}
    </Provider>
  );
};

export default BaseProvider;
